import { Site } from './site';
import { Injectable } from "@angular/core";

@Injectable()
export class SiteSerializer {
  fromJson(json: any): Site {
    const site = json

    return site
  }

  toJson(site: Site): any {
    return {
      ...site
    }
  }
}
